require('./bootstrap');
import Alpine from 'alpinejs';
window.Alpine = Alpine;
Alpine.start();

// import Chart from 'chart.js';
// import {SankeyController, Flow} from 'chartjs-chart-sankey';
// window.SankeyController = new SankeyController();
// import {Chart} from 'chart.js';
// import {SankeyController, Flow} from 'chartjs-chart-sankey';

// mix.copy([
//     'node_modules/chart.js/dist/chart.js'
// ], 'public/js/chart.js');

// mix.copy([
//     'node_modules/chartjs-chart-sankey/dist/chartjs-chart-sankey.min.js'
// ], 'public/js/chartjs-chart-sankey.min.js');

import '@logicamente.info/input-month-polyfill/dist/input-month-polyfill.min';

document.addEventListener('DOMContentLoaded', function() {
    let clearableInputs = document.querySelectorAll('[clearable]');
    clearableInputs.forEach(input => {
        input.classList.add('relative');
        input.insertAdjacentHTML('afterend', `<span class="absolute right-3 top-[50%] h-3 w-3 cursor-pointer" clearable-input>
            <div title="Clear" class="inline-block align-middle h-4 w-4 text-center rounded-full bg-gray-400 text-white font-semibold">
                <p class="mt-[-5px]">&times;</p>
            </div>
        </span>`);
    });

    window.setupTippy();
    window.setupClearableInputs();
});

const setupClearableInputs = window.setupClearableInputs = function() {
    document.querySelectorAll('[clearable-input]').forEach(input => {
        input.addEventListener('click', () => {
            input.previousElementSibling.value = '';
            input.previousElementSibling.focus();
        });
    });
}

window.addEventListener('change-element-text', ev => {
    let ID = ev.detail.data.element;
    let content = ev.detail.data.content;

    let element = document.getElementById(ID);

    if (element) {
        element.innerHTML = content;
    }
});
